<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs>
        <a-tab-pane key="1" tab="门店列表">
          <storeList :typeList='typeList' :levelList='levelList'></storeList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="门店审核管理">
          <storeReview :typeList='typeList' :levelList='levelList'></storeReview>
        </a-tab-pane>
        <template v-slot:tabBarExtraContent>
          <span class='mr15'>
            <a-button type="primary" ghost v-has:storeInvitation="()=>{visibleInvite=true}">
              门店注册地址
            </a-button>
          </span>
          <span class='mr15'>
            <a-button type="primary" ghost v-has:storeLoginUrl="()=>getStoreLink(3)">
              门店登录地址
            </a-button>
          </span>
           <span>
            <a-button type="primary" ghost v-has:storeWriteCode="()=>{writeOffSelect=[];visibleWriteCodeDownle=true;}"> 
              门店核销码
            </a-button>
          </span>
        </template>
      </a-tabs>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="添加门店申请链接" centered :footer="null" v-model:visible="visibleInvite" destroyOnClose   @cancel='formLink={}' :width="600">
    <a-form-item label="门店类型" name='' :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-row :gutter="10">
        <a-col :span="16">
          <a-select v-model:value="formLink.type_id" placeholder="请选择" :style="{width:'100%'}" @change="changeStoreType">
            <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
            </a-select-option>
          </a-select>
        </a-col>
        <!-- <a-col :span="14">
          <a-select v-model:value="formLink.level_id" placeholder="请选择" :style="{width:'100%'}">
            <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}
            </a-select-option>
          </a-select>
        </a-col> -->
      </a-row>
    </a-form-item>
    <a-form-item ref="" label="所属上级" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"  v-if="formLink.store_type!=4&&formLink.store_type" >
      <a-row :gutter="10">
        <a-col :span="8" hidden>
          <a-input readonly v-model:value='formLink.pid' placeholder="上级ID"></a-input>
        </a-col>
        <a-col :span="20">
          <a-input readonly v-model:value='formLink.name' placeholder="上级名称"></a-input>
        </a-col>
        <a-col :span="4">
          <a-button type="primary" @click='showDealer=true'>选择</a-button>
        </a-col>
      </a-row>
    </a-form-item>
      <a-form-item ref="" label="上级门店" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" v-if="formLink.store_type==4">
      <a-row :gutter="10">
        <a-col :span="8" hidden>
          <a-input readonly v-model:value='formLink.store_pid' placeholder="上级ID"></a-input>
        </a-col>
        <a-col :span="20">
          <a-input readonly v-model:value='formLink.store_name' placeholder="上级名称"></a-input>
        </a-col>
        <a-col :span="4">
          <a-button type="primary" @click='showStore=true'>选择</a-button>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
      <a-button type="primary" @click="Registered" :loading="confirmLoadingLink">
        生成申请链接
      </a-button>
    </a-form-item>
  </a-modal>
  <a-modal  :keyboard="false" title="选择经销商" v-model:visible="showDealer" centered :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect"  :mustShowHeadquarters="true" :checkout='false'></selectDealer>
  </a-modal>
    <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null" destroyOnClose>
    <selectChain v-on:select="storeSelect"  :checkout='false' :type_id="formLink.type_id" :hiddenHead="true"></selectChain>
  </a-modal>
  <a-modal  :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
     <a-modal  :keyboard="false" title="核销码" centered :width='1300'  v-model:visible="visibleWriteCodeDownle" :confirm-loading="confirmLoading" destroyOnClose @ok="handleOk">
         <storeWriteCodeDown v-on:change="changeStoreSelect"/>
    </a-modal>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import storeList from "./components/store_list";
  import storeReview from "./components/store_review";
  import storeWriteCodeDown from "./components/store_write_code_down";
  import { getPublicLevelList, getPublicTypeList, getInviteRegistered,downloadPackage } from "@/api/store";
  import { getClientsite } from "@/api/public";
  import store from '@/store'
  export default {
    components: { storeList, storeReview,storeWriteCodeDown },
    setup(props) {
      const state = reactive({
        visibleWriteCodeDownle:false,//核销码下载列表
        visibleUrl: false,
        typeList: [],
        levelList: [],
        info:store.state.user.info,
        link: {
          image: "",
          link: "",
        },
        showDealer: false,//选择经销商
        showStore:false,//选择门店
        visibleInvite: false,
        confirmLoadingLink:false
      });
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      // 获取类型列表
      const getType = async () => {
        let res = await getPublicTypeList().then((res) => res.data);
        if (iscode(res)) {
          state.typeList = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      //获取等级列表
      const getLvevl = async () => {
        let res = await getPublicLevelList().then((res) => res.data);
        if (iscode(res)) {
          state.levelList = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      // 获取门店地址
      const getStoreLink = async (client_type) => {
        let result = await getClientsite({ client_type }).then((res) => res.data).catch((error) => error);
        state.link = result.data;
        state.visibleUrl = true;
      };
      // 复制
      const copy = (link) => {
        var input = document.createElement("input"); // 直接构建input
        input.value = link; // 设置内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        message.success("复制成功");
      };
      onMounted(() => {
        getType();
        getLvevl();
        // initData(search.value);
      });
      const formLink = ref({});
      const dealerSelect = (data) => {
        state.showDealer = false
        if (data == 0) {
          formLink.value.pid = 0
          formLink.value.name = '总部'
          return
        }
        formLink.value.pid = data.dealer_id
        formLink.value.name = data.dealer_name
      }
      const changeStoreType=(e)=>{
        state.typeList.forEach(element => {
            if(element.type_id==e){
              formLink.value.store_type=element.store_type
            }
        });
      }
      const storeSelect=(data)=>{
        state.showStore = false
        formLink.value.store_pid = data.id
        formLink.value.store_name = data.store_name
      }
      const Registered = async () => {
        // 连锁分店 的时候必须选择上级门店
        if(formLink.value.store_type==4&&!formLink.value.store_pid){
          message.error('请选择上级门店');
          return
        }
        state.confirmLoadingLink = true
        let res = await getInviteRegistered({ ...formLink.value }).then(res => res.data).catch(error => error)
        if (iscode(res)) {
          state.link = {...res.data,link:res.data.url}
          state.visibleUrl = true;
          state.visibleInvite=false
        } else {
          message.error(res.msg);
        }
        state.confirmLoadingLink = false
      }
      // 获取门店核销码
      const getStoreWriteOf=async()=>{

      }
      const confirmLoading=ref(false)
      const  writeOffSelect=ref([])
      const changeStoreSelect=(e)=>{
        if(!e.bubbles){
        writeOffSelect.value=e
        }
      }
      const handleOk=async ()=>{
        if(!writeOffSelect.value.length){
          message.error('请选择门店')
          return
        } 
        confirmLoading.value=true
        let result=await downloadPackage({store_ids:writeOffSelect.value}).then(res=>res.data).catch(error=>error)
        confirmLoading.value=false
        if(iscode(result,true)){
          window.open(state.info.picdomain+result.data.zipfile)
        }
      }
    
      return {
        ...toRefs(state),
        getStoreLink,
        changeStoreType,
        copy,
        formLink,
        dealerSelect, 
        Registered,
        getStoreWriteOf,
        changeStoreSelect,
        storeSelect,
        handleOk,
        writeOffSelect,
        confirmLoading,
   
      };
    },
  };
</script>